import { AccordionContent, AccordionItem } from '@talentmesh/ui/components/accordion';
import InfoChoiceSelector from './components/InfoChoiceSelector';
import RequestInformationAccordionTrigger from './components/RequestInformationAccordionTrigger';
import ApplicantInformationType from '@/Models/ApplicantInformationType';
import getApplicantInformationLabel from '@/Utils/getLabelsFunctions';
import UIStrings from '@/Utils/UIStrings';

const motivationalInformationToggles: ApplicantInformationType[] = [
    ApplicantInformationType.ReasonForApplying,
    ApplicantInformationType.ReasonForLeaving,
];

const MotivationalInformatioAccordion = () => {
    return (
        <AccordionItem value={UIStrings.MotivationalInformation}>
            <RequestInformationAccordionTrigger>{UIStrings.MotivationalInformation}</RequestInformationAccordionTrigger>
            <AccordionContent>
                {motivationalInformationToggles.map((value) => (
                    <InfoChoiceSelector
                        key={ApplicantInformationType[value]}
                        label={getApplicantInformationLabel(value)}
                        name={value}
                    />
                ))}
            </AccordionContent>
        </AccordionItem>
    );
};

export default MotivationalInformatioAccordion;
